import { Section, Prose, NavLink, Link } from "@liberetech/design-system";
import classNames from "classnames";

import {
  IconExpressCheckIn,
  IconMobileKey,
  IconOnlineReception,
  IconStar,
  IconWiFi,
} from "../AssetHomeIcon/AssetHomeIcon";

import { useBrand } from "components/Context/BrandContext";
import { useTranslation } from "lib/i18n/client";

import { AssetHomeIntroAssetFragment } from "./AssetHomeIntro.generated";
import styles from "./AssetHomeIntro.module.css";

const AssetHomeIntro: React.FC<AssetHomeIntroProps> = ({
  asset,
  content,
  offlineReception,
}) => {
  const { t } = useTranslation("asset");

  const brand = useBrand();
  return (
    <Section>
      <div className={classNames(styles.features, "grid")}>
        <Prose className={styles.featuresDescription}>
          {asset?.reviews && asset?.reviews.nodes.length > 0 && (
            <div className={styles.reviews}>
              <IconStar />
              <span>
                <strong>{asset.reviews.averageRating}</strong>/5
              </span>
              <NavLink href="#reviews">
                <Link>{t("reviews.see")}</Link>
              </NavLink>
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </Prose>
        <div className={styles.topAmenities}>
          <h3 className={styles.topAmenitiesTitle}>{t("amenities.top")}</h3>
          <ul className={styles.topAmenitiesList}>
            {[
              brand.app &&
                !asset?.access?.isStandalone && {
                  icon: <IconMobileKey />,
                  title: t("feature.mobileKey"),
                },
              {
                icon: <IconOnlineReception />,
                title: offlineReception
                  ? t("feature.offlineReception")
                  : t("feature.onlineReception"),
              },
              {
                icon: <IconWiFi />,
                title: t("feature.wifi"),
              },
              !!asset?.access?.isStandalone && {
                icon: <IconExpressCheckIn />,
                title: t("feature.expressCheckin"),
              },
            ]
              .filter((f) => !!f)
              .map((amenity, i) => (
                <li key={i} className={styles.topAmenitiesItem}>
                  {amenity.icon}
                  <p>{amenity.title}</p>
                </li>
              ))}
          </ul>
          <NavLink href="#amenities" className={styles.topAmenitiesLink}>
            <Link>{t("amenities.seeAll")}</Link>
          </NavLink>
        </div>
      </div>
    </Section>
  );
};

type AssetHomeIntroProps = {
  asset: AssetHomeIntroAssetFragment | null;
  content: string;
  offlineReception: boolean;
};

export default AssetHomeIntro;
